// extracted by mini-css-extract-plugin
module.exports = {"main":"page_main__nw1Wk"};